import React, { useState } from 'react'
import './profile-navbar.css';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.svg'
import { FaBars, FaEnvelope, FaBell } from 'react-icons/fa';
import picture from '../../images/pic.png'
import settings from '../../images/settings.svg'
import { Navbar, Nav, Offcanvas, Container } from 'react-bootstrap';
import { EmployerCollapsedMenu } from '../../data';
import signout from '../../images/sign-out.svg'
import setting from '../../images/settings.svg'
import EmployerSettings from '../../pages/profile/Employer/Settings/employer-settings';


const EmployerNavbar = () => {
  

  const [modalShow, setModalShow] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  }
 
  const handleCloseToggle =()=> {
    setIsOpen(false);
  }

 

  

  const handleModalClose = () =>{
    setModalShow(false);
    handleCloseToggle();
  } 
  const handleModalShow = () => {
    setModalShow(true);
    handleCloseToggle();
  } 
 
  
  
   
    return (
        <div>
             {['xl'].map((expand) => (
          <Navbar key={expand} expand={expand} style={{background: '#CCDFF0'}}className='pe-3'>
          
            <Navbar.Brand >
                <Link to='/' className='p-0 m-0'>
                 <img src={logo} />
               </Link>
            </Navbar.Brand>
            
            
               <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} onClick={handleToggle}/>
               <Navbar.Offcanvas 
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end" style={{ backgroundColor: 'white' }} className= {`${isOpen ? 'show d-xl-none' : 'hide'}`} onHide={handleCloseToggle}
            >
              <Offcanvas.Header closeButton style={{ backgroundColor: 'white' }}>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
               
                 <img src={picture}/>
                
                </Offcanvas.Title>
              </Offcanvas.Header>
              <div className='line d-xl-none'></div>
              <Offcanvas.Body className=''>
                <Nav className=''>
                {
                EmployerCollapsedMenu.map((menu) => {
                  const {id,icon,text,url} = menu;
                  return(
                    <Nav.Link>
                     <Link to={url} className='collapsed-text gap-3'>
                     <img className='' src={icon} style={{width:'50px', height:'50px'}}/> &nbsp; &nbsp; 
                      {text}
                     </Link>
                    </Nav.Link>
                  )
                  })
                }
              <Nav.Link className='d-flex gap-4' onClick={handleModalShow}>
                  
                  <img src={setting} style={{width:'50px', height:'50px'}}/> 
                  <p className='collapsed-text my-auto'>Settings</p>
            </Nav.Link>
            {modalShow && <EmployerSettings 
             
             onHide={handleModalClose}
             />}

              
             <div className='line my-4'></div>
             <Link to='/employerlogin' className='d-flex align-items-center collapsed-text '>
               <img src={signout} style={{width:'50px', height:'50px'}}/> &nbsp; &nbsp; <h4 className=' '>Sign Out</h4>
             </Link>
            </Nav> 
                         
              </Offcanvas.Body>
              
             
            </Navbar.Offcanvas>
            <Navbar.Offcanvas 
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end" style={{ backgroundColor: 'white' }} className='d-none d-xl-flex'
            >
              <Offcanvas.Header closeButton style={{ backgroundColor: 'white' }}>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
               
                 <img src={picture}/>
                
                </Offcanvas.Title>
              </Offcanvas.Header>
              <div className='line d-xl-none'></div>
             
              
              <Offcanvas.Body className='align-items-center'>
                <Nav className='me-auto gap-4 px-5 mx-5'>
                  <Nav.Link><Link to='/employerdashboard' className='link-dark text-decoration-none'>Dashboard</Link></Nav.Link>

                  <Nav.Link><Link to='/postjobs' className='link-dark text-decoration-none'>Post Jobs</Link></Nav.Link>

                 <Nav.Link>
                 <Link to='/feedback' className='link-dark text-decoration-none'>Post Feedbacks</Link></Nav.Link>
                </Nav> 
                <Nav className='gap-3 mt-1'>
                  <Nav.Link>
                  <Link to='/employerprofile' className=''><img src={picture}className='pt-1'/></Link>
                  </Nav.Link>
                 
                  <Nav.Link>
                 <Link to='/employermessages' className='my-auto text-decoration-none'><FaEnvelope className='envelope'/><sup className='super'>0</sup></Link>
                 </Nav.Link>
                 <Nav.Link >
                 <Link to='/employernotifications' className='my-auto text-decoration-none'><FaBell className='envelope'/><sup className='super text-decoration-none'>0</sup></Link>
                 </Nav.Link>
                 <Nav.Link className='my-auto text-decoration-none' onClick={handleModalShow}>
                    
                                        <img src={setting} className='envelope'/> 
                </Nav.Link>
                <EmployerSettings
                 show={modalShow}
                 onHide={handleModalClose}
                 />
                 <Nav.Link>
                 <Link to='/employerlogin' className='profile-btn-1 profile-btn-tertiary text-decoration-none'> Sign Out
                 </Link>
                 </Nav.Link> 
                 
                   
                </Nav>          
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          
         </Navbar>
      ))}
            
        
           
        </div>
    )
}

export default EmployerNavbar
